// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CalendarCancelation from '../_raw/ui/icon_calendar_cancelation.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CalendarCancelation);
